import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { CLUB_CURRENCY } from 'Src/consts/club';
import { CurrencyInput } from 'Src/components/CurrencyInput/CurrencyInput';
import { CURRENCY_TYPE } from 'Src/types/common';
import { AppUser } from 'Src/views/App/App';
import { getName, searchFunctionPaymentAccounts } from 'Src/helpers/autocomplete/autocomplete';
import { Autocomplete } from 'Src/components/Autocomplete/Autocomplete';
import { ClubWizardErrors } from '../ClubWizard';
import '../ClubWizard.scss';

interface Props {
  user: AppUser;
  isPaymentRequired: boolean;
  paymentAccount: any;
  price: any;
  errors: ClubWizardErrors;
  onPriceChange: (price: string) => void;
  onPaymentAccountChange: (paymentAccountId: string) => void;
  onIsPaymentRequiredChange: (isPaymentRequired: boolean) => void;
}

export class ClubPaymentSettingsStep extends Component<Props> {
  getPaymentAccounts = () => {
    const { user } = this.props;
    return searchFunctionPaymentAccounts(user);
  };

  render() {
    const {
      price: priceObj,
      onPaymentAccountChange,
      paymentAccount,
      isPaymentRequired,
      onIsPaymentRequiredChange,
      onPriceChange,
      errors
    } = this.props;

    const currency = propz.get(priceObj, ['currency'], CLUB_CURRENCY.POUND);
    const price = propz.get(priceObj, ['price'], 0);

    return (
      <div className="clubWizardDsStep">
        <section className="clubWizardDsSection">
          <div className="clubWizardDsSection__head">
            <span className="clubWizardDsSection__icon">£</span>
            <div>
              <h3>Payment settings</h3>
              <p>Turn on payments only when families need to pay to book a place.</p>
            </div>
          </div>

          <div className="clubWizardDsToggleRow">
            <div>
              <strong>Payment required</strong>
              <span>Families pay to book a place. Turn off for a free club.</span>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={isPaymentRequired}
              className={`clubWizardDsSwitch ${isPaymentRequired ? 'isOn' : ''}`}
              onClick={() => onIsPaymentRequiredChange(!isPaymentRequired)}
            >
              <span />
            </button>
          </div>

          {isPaymentRequired ? (
            <div className="clubWizardDsGrid clubWizardDsGrid--two">
              <label className="clubWizardDsField clubWizardDsField--wide">
                <span>Payment account</span>
                <div className="clubWizardDsAutocomplete">
                  <Autocomplete
                    searchFunction={this.getPaymentAccounts}
                    getElementTitle={getName}
                    customClass="mFullWidth"
                    defaultItem={paymentAccount}
                    placeholder="Choose an account"
                    onSelect={paymentAccountCurrent => onPaymentAccountChange(paymentAccountCurrent)}
                  />
                </div>
                {errors.paymentAccount && <em>Required</em>}
              </label>

              <label className="clubWizardDsField">
                <span>Price</span>
                <div className="clubWizardDsCurrency">
                  <CurrencyInput
                    currency={currency as CURRENCY_TYPE}
                    onChange={value => onPriceChange(value)}
                    value={String(price)}
                    disabled={false}
                  />
                </div>
                {errors.price && <em>Required, enter a number please</em>}
              </label>
            </div>
          ) : (
            <div className="clubWizardDsNotice">This club is free. No payment account or price is needed.</div>
          )}
        </section>
      </div>
    );
  }
}
